import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppStateService } from "../services/app-state/app-state.service";

@Injectable({
  providedIn: "root",
})
export class AuthGaurd {
  constructor(
    private appStateService: AppStateService,
    private router: Router
  ) {}
  canActivate(
    _route: ActivatedRouteSnapshot,
    _router: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    // Live session check on every navigation (rather than trusting cached client state) —
    // the session cookie can expire or be revoked server-side between navigations.
    return this.appStateService
      .checkSession()
      .pipe(map((isAuth) => (isAuth ? true : this.router.createUrlTree(["/login"]))));
  }
}
